import { render, staticRenderFns } from "./feedbackModal.vue?vue&type=template&id=5989d906"
import script from "./feedbackModal.vue?vue&type=script&lang=js"
export * from "./feedbackModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports